import SearchPartsExtraFilters from '@/components/SearchParts/SearchPartsExtraFilters';
import AppPageHeader from '@/components/_common/AppPageHeader';
import {
  ListStockItemsQuery,
  StockItemType,
} from '@/core/domain/stock/StockItems/StockItems.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

interface Props extends ExtraFiltersProps<ListStockItemsQuery> {
  itemType?: StockItemType;
}

const FiltersItemsStockModal: React.FC<Props> = ({ setQueryParams }) => {
  return (
    <>
      <AppPageHeader
        onSearch={(value: string) =>
          setQueryParams((prev) => ({ ...prev, search: value }))
        }
        extraFilters={
          <SearchPartsExtraFilters
            setQueryParams={setQueryParams}
            showVehicleFields={false}
          />
        }
      />
    </>
  );
};

export default FiltersItemsStockModal;
